export default {
    general: {
        language: "en-US",
        fontSize: "STANDARD",
        dateFormat: "MMDDYYYY",
        currency: "USD",
        timeZone: "76"
    },
    reportCover: {
        preparedBy: "",
        preparedByTitle: "",
        firmName: "",
        date: "0",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        telephoneNumber: "",
        emailAddress: ""
    },
    reportGeneral: {
        reportLanguage: "en-US",
        reportFontSize: "0",
        reportDateFormat: "MMDDYYYY",
        releaseDate: "0",
        printOrientation: "0"
    },
    portfolio: {
        portfolioAllocation: {
            initialInvestment: 10000.0,
            priceDate: "0",
            portfolioAccountType: "254",
            allocateBy: 0
        },
        feeSetting: {
            annualFeePayOnBegin: false,
            frontLoadType: 0,
            frontLoadAmountType: 0,
            customFeesAmount: 0.0,
            redemptionCharge: true,
            includeTransactionFee: true,
            includeAdvisoryFee: false,
            loi: true,
            annualFeeAmount: 0,
            chargeOnRebalancing: false,
            annualFeePayMethod: 0,
            annualFeeChargeFrequency: 1,
            annualFeePayCashFirst: true
        },
        attributes: {
            annualContributionAmount: 0.0,
            annualContributionType: "",
            trackingMethod: "1",
            includeInTotal: "1",
            status: "0"
        }
    },
    hypothetical: {
        timePeriod: 7,
        reportSetting: {
            idrReturnDisplayPeriod: 3,
            includeNetAmountInvested: true
        },
        subSequentSetting: {
            include: true,
            type: 0,
            frequency: 1,
            amount: 0.0,
            amountType: 0,
            liquidateOnEndDate: false
        },
        rebalanceSetting: {
            includeRebalance: true,
            rebalancingTo: 0,
            rebalanceFrequency: 12,
            rebalanceThreshold: 0.0
        },
        reinvestSetting: {
            include: true,
            reinvestDividends: true,
            reinvestCapitalGains: true
        },
        taxSetting: {
            includeTax: false,
            filingStatus: 1,
            taxableIncome: 100000.0,
            taxPayOption: 0,
            taxRate: {
                federalIncomeTaxRate: 0,
                capitalGainsTaxRate: 0,
                stateTaxRate: 0
            }
        },
        benchmarkSetting: {
            benchmarkType: 0,
            includeBenchmark: true,
            benchmarkHoldings: [
                {
                    securityId: "XIUSA04G92",
                    securityName: "S&P 500 TR USD",
                    identifier: "XIUSA04G92"
                }
            ]
        },
        reportOptions: [
            {
                reportId: "CoverPage",
                settings: {
                    reportTitle: "Performance Report"
                },
                include: true
            },
            {
                reportId: "MarketingPage",
                include: false
            },
            {
                reportId: "DistributionWithdrawalComparison",
                include: false
            },
            {
                reportId: "PortfolioComparison",
                include: false
            },
            {
                reportId: "DistributionWithdrawal",
                include: false
            },
            {
                reportId: "XRay",
                include: false
            },
            {
                reportId: "Snapshot",
                include: true
            },
            {
                reportId: "StockIntersection",
                include: true
            },
            {
                reportId: "CAPortfolioSummary",
                include: false
            },
            {
                reportId: "CAPortfolioServiceFees",
                include: false
            },
            {
                reportId: "RiskReward",
                include: true
            },
            {
                reportId: "CorrelationMatrix",
                include: true
            },
            {
                reportId: "TotalAnnualReturn",
                include: false
            },
            {
                reportId: "InvestmentGrowth",
                include: true
            },
            {
                reportId: "PortfolioRollingReturn",
                include: false
            },
            {
                reportId: "RollingReturn",
                include: false
            },
            {
                reportId: "InvestmentDetail",
                include: true
            },
            {
                reportId: "UnderlyingHolding",
                include: true
            },
            {
                reportId: "PriceDistribution",
                include: false
            },
            {
                reportId: "Cashflow",
                include: true
            },
            {
                reportId: "CAFundSummary",
                include: false
            },
            {
                reportId: "CAStockSummary",
                include: false
            },
            {
                reportId: "MORGInvestmentSummary",
                include: false
            },
            {
                reportId: "BLKManagementFees",
                include: false
            },
            {
                reportId: "Disclosure",
                include: true
            },
            {
                reportId: "Sustainability",
                include: false
            },
            {
                reportId: "Carbon",
                include: false
            }
        ]
    }
};
